module.exports = __webpack_public_path__ + "img/img.f45e4009.jpg";